<template>
  <div>

    <table
    :class="['final-table th-no-padding lines-b lines-r full-width', {'hover pointer': selectedCount !== 0}]"
    >
      <colgroup ref="colgroup1">
        <col width="10px" />
        <col width="8px" />
        <col width="10px" />
      </colgroup>
      <tr>
        <c-table-header
          title="Name"
          code="name"
          :filters="filters"
          @onClick="clickSortHeader"
        ></c-table-header>
        <c-table-header title="RID" code="rid" :filters="filters" @onClick="clickSortHeader"></c-table-header>
        <c-table-header
          title="Quantity"
          code="quantity"
          :filters="filters"
          @onClick="clickSortHeader"
        ></c-table-header>
      </tr>
      <tr>
        <td class="sticky">
          <v-text-field
            v-model="filters.search.name"
            placeholder="Search..."
            hide-details
            class="crx-box-input"
            clearable
            color="color1"
            solo
          ></v-text-field>
        </td>
        <td></td>
        <td></td>
      </tr>
    </table>

    <misc-group-row 
    v-if="Object.keys(itemSource.custom_items).length"
    :custom_items="itemSource.custom_items"
    :selected="selectedMain"
    :savedInputs="savedInputs"
    :mergeMap="mergeMap"
    :inventoryView="inventoryView"
    :searchFilters="filters.search"
    :showAllBoxesMode="showAllBoxesMode"
    :boxOrderIDMap="boxOrderIDMap"
    class="ma-2"
    @checkRow="$emit('checkRow', $event)">

    </misc-group-row>

    <list-row
    v-for="item in paginatedArray"
    :key="(item.definition || {}).id"
    :item="item"
    :selected="selectedMain"
    :savedInputs="savedInputs"
    :mergeMap="mergeMap"
    :inventoryView="inventoryView"
    :searchFilters="filters.search"
    :showAllBoxesMode="showAllBoxesMode"
    :boxOrderIDMap="boxOrderIDMap"
    class="ma-2"
    @checkRow="$emit('checkRow', $event)"
    @click.native="clickRow(item)"
  ></list-row>

    <!-- PAGINATION -->
    <c-pagination-client
    :page="page"
    :paginationLength="paginationLength"
    :paginatedArray="paginatedArray"
    :rowsPerPage.sync="rowsPerPage"
    @updatePageNumber="updatePageNumber"
    @goToFirstPage="goToFirstPage"
    @goToPreviousPage="goToPreviousPage"
    @goToNextPage="goToNextPage"
    @goToLastPage="goToLastPage">
    </c-pagination-client>
    <!-- PAGINATION -->

  </div>
</template>

<script>
import ListController from "@/mixins/ListController"
import ListRow from "./group-row"
import MiscGroupRow from './misc-group-row'

export default {
  props: {
    itemSource: null,
    savedInputs: null,
    mergeMap: null,
    inventoryView: null,
    selectedMain: null,
    showAllBoxesMode: null,
    boxOrderIDMap: null
  },
  components: {
    ListRow,
    MiscGroupRow
  },
  mixins: [ListController],
  data () {
    return {
      filters: {
        rowsPerPage: 10,
        sortCol: "name",
        sortAscending: true,
        date: {
          mainSelect: "is equal to",
          isInTheLast_select: "days",
          isInTheLast_input: null,
          date1: null,
          date2: null
        },
        search: {
          id: "",
          name: ""
        },
        active: {
          customer: false,
          date: false,
          deleted: false
        },
        categories: []
      }
    }
  },
  computed: {
    misc_items () {
      return Object.values(this.itemSource.custom_items)
    }
  },
  watch: {
    itemSource: {
      immediate: true,
      handler (itemMap) {
        this.items = Object.values(itemMap.normal_items)
        this.resort()
      }
    },
    items (nv) {
      // this.$emit('update:itemsSource', nv)
    }
  },
  methods: {
    clickRow(item) {
      if (this.selectedCount > 0) {
        this.checkRow(item);
      }
    },
    sort (items) {
      if (this.filters.sortCol === 'name') {
        return items.sort((a, b) => {
          return this.filters.sortAscending ? a.definition.name.localeCompare(b.definition.name) : b.definition.name.localeCompare(a.definition.name)
        })
      } /* else if (headerIndex === 2) { // Date of entry
        return items.sort((a, b) => {
          return sortAscending ? new Date(b.date_of_entry) - new Date(a.date_of_entry) : new Date(a.date_of_entry) - new Date(b.date_of_entry)
        })
      } else if (headerIndex === 3) { // Expiry
        return items.sort((a, b) => {
          return sortAscending ? new Date(b.expiry_date) - new Date(a.expiry_date) : new Date(a.expiry_date) - new Date(b.expiry_date)
        })
      } else if (headerIndex === 4) { // Supplier
        return items.sort((a, b) => {
          var supplierA = (this.$store.state.db.suppliers.suppliers[a.supplier_id] || {}).name || ''
          var supplierB = (this.$store.state.db.suppliers.suppliers[b.supplier_id] || {}).name || ''
          return sortAscending ? supplierA.localeCompare(supplierB) : supplierB.localeCompare(supplierA)
        })
      } */
    },
    search (items) {
      if ((this.filters.search.name || '').length > 0) {
        var keywords = (this.filters.search.name || '').toLowerCase().split(' ')
        items = items.filter(item => {
          return keywords.every(keyword => {
            return (item.definition.name.toLowerCase()).indexOf(keyword) > -1
          })
        })
      }
      return items
    },
  }
}
</script>